<span class="text-nowrap">
    <i *ngIf="draftCommentCount > 0" class="far fa-comment" title="Draft Comments"></i>
    <i *ngIf="publishedCommentCount > 0" class="far fa-comment-dots" title="Published Comments"></i>
</span>
